import { formatMoney } from 'libs/shopify'

function Price({ className = '', price = 0, originalPrice = null, classSize = 'text-xs-short tracking-base', classColor = 'text-grey-800', hasComman = false }) {
  const customClass = `price ${className}`
  const isSale = originalPrice && originalPrice !== 0 && originalPrice > price
  const colorPrice = `${classSize} ${classColor}`

  /* eslint-disable-next-line no-template-curly-in-string */
  const format = hasComman ? '${{ amount }}' : '${{ amount_no_decimals_with_comma_separator }}'

  return (
    <div className={customClass}>
      <div className={colorPrice}>{formatMoney(price)}</div>
      {isSale ? <div className={`text-grey-600 line-through ${classSize}`}>{formatMoney(originalPrice)}</div> : ''}
    </div>
  )
}

export default Price
